import { useId } from "react";
import { trackInventoryEvent } from "../../constants/automapDealerInventoryConstants";
import {
  buildDealerListingPublicLinkAnalytics,
  getDealerListingPublicUrl,
  getDealerListingPublicUrlUnavailableMessage,
} from "../../utils/dealerListing/dealerListingPublicUrl";

/**
 * Dealer portal "View public" action using M3 identity metadata (M5).
 */
export default function DealerListingPublicAction({
  listing,
  locale,
  t,
  className = "dealer-portal-btn",
  label,
  dealerId = null,
  showUnavailableHint = true,
  icon = "↗ ",
}) {
  const hintId = useId();
  const publicUrl = getDealerListingPublicUrl(listing, { locale });
  const actionLabel = label || t("inventoryDetail.viewPublic");

  const handleClick = () => {
    trackInventoryEvent("dealer_listing_view_public", {
      dealerId,
      ...buildDealerListingPublicLinkAnalytics(listing, publicUrl),
    });
  };

  if (!publicUrl) {
    const unavailableMessage = getDealerListingPublicUrlUnavailableMessage(listing, t);
    return (
      <span className="dealer-listing-public-action dealer-listing-public-action--unavailable">
        <button
          type="button"
          className={`${className} dealer-listing-public-action__disabled`}
          disabled
          aria-describedby={showUnavailableHint ? hintId : undefined}
          title={unavailableMessage}
        >
          {icon}
          {actionLabel}
        </button>
        {showUnavailableHint ? (
          <span id={hintId} className="dealer-listing-public-action__hint muted">
            {unavailableMessage}
          </span>
        ) : null}
      </span>
    );
  }

  return (
    <a
      className={`dealer-listing-public-action__link ${className}`}
      href={publicUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
    >
      {icon}
      {actionLabel}
    </a>
  );
}
